import React from 'react';
import { useHistory } from 'react-router-dom';
import DialogBox from '../../components/user/common/DialogBox';

const RedirectionError = () => {
    const history = useHistory();

    const dialogConfirmMethod = () => {
        history.push('/logout'); // Use history.push for navigation
    }

    return (
        <DialogBox
            showResetDialog={true}
            handleCloseDialog={null}
            handleConfirmDialog={dialogConfirmMethod}
            dialogTitle='errors.redirection_error_title'
            dialogText='errors.redirection_error_text'
            dialogCancelText={null}
            dialogConfirmText='errors.redirection_error_btn'
            isRedirectionError={true}
        />
    )
}

export default RedirectionError;